/* LoWell home.js (startseite): Stil-Filter der Hut-Motive (Motivwelt, Kollektion) und „Alle Motive zeigen“.
   Ohne JS sind alle Motive sichtbar. Bereich: [data-stil-scope], Knöpfe [data-stil-filter], Raster [data-stil-grid],
   Einträge [data-stil], Mehr-Knopf [data-stil-more]; JS-Bedienelemente tragen [data-stil-js] und starten verborgen. */
(() => {
  const L = (window.lowell = window.lowell || {});
  if (L.stilFilter) return;
  L.stilFilter = true;
  const doc = document;
  const say = (scope, n) => {
    const t = scope.dataset.announce;
    if (t && L.announce) L.announce(t.replace('[count]', n));
  };
  const init = () => doc.querySelectorAll('[data-stil-scope] [data-stil-js]').forEach((el) => (el.hidden = false));
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init);
  else init();

  doc.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-stil-filter]');
    const more = e.target.closest('[data-stil-more]');
    const scope = (btn || more) && (btn || more).closest('[data-stil-scope]');
    if (!scope) return;
    const grid = scope.querySelector('[data-stil-grid]');
    if (!grid) return;
    if (more) {
      grid.classList.remove('is-collapsed');
      more.hidden = true;
      const next = grid.querySelector('.mw__item--extra:not([hidden]) a');
      if (next) next.focus();
      return;
    }
    const stil = btn.dataset.stilFilter;
    scope.querySelectorAll('[data-stil-filter]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    let n = 0;
    grid.querySelectorAll('[data-stil]').forEach((item) => {
      const on = stil === 'alle' || item.dataset.stil === stil;
      item.hidden = !on;
      if (on) n += 1;
    });
    if (stil !== 'alle') {
      grid.classList.remove('is-collapsed');
      const m = scope.querySelector('[data-stil-more]');
      if (m) m.hidden = true;
    }
    say(scope, n);
  });
})();
